module.exports = __webpack_public_path__ + "static/media/24.54e3f719.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/pants/24.png
// module id = 1398
// module chunks = 0